import { useNavigate } from "react-router-dom";
import { formatAmount } from "../../utility/Common";
import { RoutePaths } from "../../utility/RoutePaths";

const PaymentBanner = ({ classId, date, price, type = 1 }) => {
  const navigate = useNavigate();
  if (type === 2) {
    return (
      <div className="bg-primary-600 text-white rounded-lg shadow-md p-6 mb-6 border-l-4">
        <div className="flex flex-col items-center justify-between">
          <p className="text-white">
            සම්මන්ත්‍රණයට සම්බන්ධ වීමට මාසික ගාස්තුව ගෙවන්න.
          </p>
          <h2 className="text-2xl font-bold text-white mt-4">
            {formatAmount(price, true)}
          </h2>
          <button
            onClick={() =>
              navigate(
                `${RoutePaths.STUDENT_SEMINAR_PAYMENT_PAGE}?seminarId=${classId}`,
              )
            }
            className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 font-medium transition-colors mt-4"
          >
            Pay
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div className="bg-primary-600 text-white rounded-lg shadow-md p-6 mb-6 border-l-4">
        <div className="flex flex-col items-center justify-between">
          <p className="text-white">
            සියලුම පන්ති සැසිවලට සම්බන්ධ වීමට මාසික ගාස්තුව ගෙවන්න.
          </p>
          <h2 className="text-2xl font-bold text-white mt-4">
            {formatAmount(price, true)}
          </h2>
          <button
            onClick={() =>
              navigate(
                `${RoutePaths.STUDENT_CLASS_MONTH_PAYMENT_PAGE}?classId=${classId}&date=${date}`,
              )
            }
            className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 font-medium transition-colors mt-4"
          >
            Pay
          </button>
        </div>
      </div>
    );
  }
};

export default PaymentBanner;
